
import {
    TextBoxComponent,
    TextBoxModel,
    ChangedEventArgs as tbChangedEventArgs,
} from '@syncfusion/ej2-react-inputs';
import { Control, Controller, RegisterOptions } from 'react-hook-form';

type ControlledProps = {
    name: string;
    control: Control<any>;
    defaultValue?: any;
    rules?: Omit<RegisterOptions, 'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'> | null;
    onChangeHandler?: (value: any) => void;
};

type TextBoxProps = ControlledProps & {
    multiline?: boolean;
    boxAttrs?: TextBoxModel;
};

//Replace non-ascii dashes and non-ascii space character with ascii dash and space
const replaceNonASCIIDashesAndSpace = (text) => {
    return text.replace(/[\u2013\u2014\u2015]/g, '-').replace(/[^\x20-\x7E]/g, ' ');
}

const ControlledProviderDataTextBox = ({
    name,
    control,
    defaultValue = null,
    rules = null,
    multiline = false,
    boxAttrs,
    onChangeHandler
}: TextBoxProps) => (
    <Controller
        name={name}
        control={control}
        defaultValue={defaultValue as any}
        rules={rules ?? {}}
        render={({ field: { onChange, value } }) => (
            <TextBoxComponent
                {...boxAttrs}
                htmlAttributes={{
                    ...boxAttrs?.htmlAttributes,
                }}
                multiline={multiline}
                change={({ value }: tbChangedEventArgs) => {
                    const replacedValue = value ? replaceNonASCIIDashesAndSpace(value) : null
                    onChange(replacedValue?.length ? replacedValue : null);
                    if (onChangeHandler) onChangeHandler(replacedValue);
                }}
                value={value}
            />
        )}
    />
);

export default ControlledProviderDataTextBox;